var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#F6F9f7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5300_109258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H38V38H10V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5300_109258)",
    transform: "translate(48 0) scale(-1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4562 30.1501C14.9108 30.1501 16.0922 31.3314 16.0922 32.786C16.0922 34.2406 14.9108 35.4219 13.4562 35.4219C12.0016 35.4219 10.8203 34.2406 10.8203 32.786C10.8203 31.3314 12.0016 30.1501 13.4562 30.1501Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7277 30.1501C20.1823 30.1501 21.3636 31.3314 21.3636 32.786C21.3636 34.2406 20.1823 35.4219 18.7277 35.4219C17.2731 35.4219 16.0918 34.2406 16.0918 32.786C16.0918 31.3314 17.2731 30.1501 18.7277 30.1501Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9074 30.1501C33.362 30.1501 34.5433 31.3314 34.5433 32.786C34.5433 34.2406 33.362 35.4219 31.9074 35.4219C30.4528 35.4219 29.2715 34.2406 29.2715 32.786C29.2715 31.3314 30.4528 30.1501 31.9074 30.1501Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8203 32.7891V26.6385H22.2427V32.7891H21.3641",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2422 16.9734H23.9995C25.4555 16.9734 26.6355 18.1534 26.6355 19.6094H27.5141C28.9125 19.6094 30.2532 20.1647 31.2417 21.1536C32.2306 22.1421 32.786 23.4828 32.786 24.8812L37.1792 26.6385V32.7891H34.5433C34.5433 31.3331 33.3632 30.1531 31.9073 30.1531C30.4514 30.1531 29.2714 31.3331 29.2714 32.7891H22.2422V16.9734Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8789 12.5792L26.6362 14.3364V29.2734",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6367 19.6032V24.875H32.7873",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckHome);
export default __webpack_public_path__ + "static/media/truck_home.bd8d59561d693caa384d9e596e43587a.svg";
export { ForwardRef as ReactComponent };